import React, { PropTypes } from 'react'
import data from '../../../core/data';

import Energizer from '../../../images/p-peel/energizer.png';
import Calm from '../../../images/p-peel/calm.png';
import Clear from '../../../images/p-peel/clear.png';
import Restore from '../../../images/p-peel/restore.png';

const Treatments = (props) => {
  const EnergBody = data.ppeel.treatments.energise;
  const CalmBody = data.ppeel.treatments.calm;
  const ClearBody = data.ppeel.treatments.clear;
  const RestoreBody = data.ppeel.treatments.restore1;
  const RestoreBold = data.ppeel.treatments.restoreBold;
  const RestoreBody2 = data.ppeel.treatments.restore2;
  return (
    <section id="p-peel-treatments">
      <div className="container">
        <div className="table-responsive">
          <table>
            <tbody>
              <tr>
                <th className="logo"><img src={ Energizer } /></th>
                <th><p>{ EnergBody }</p></th>
              </tr>
              <tr>
                <th className="logo"><img src={ Calm } /></th>
                <th><p>{ CalmBody }</p></th>
              </tr>
              <tr>
                <th className="logo"><img src={ Clear } /></th>
                <th><p>{ ClearBody }</p></th>
              </tr>
              <tr>
                <th className="logo restore"><img src={ Restore } /></th>
                <th>
                  <p>{ RestoreBody }</p>
                  <p><b>{ RestoreBold }</b></p>
                  <p>{ RestoreBody2 }</p>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

export default Treatments;



/** WEBPACK FOOTER **
 ** ./src/components/containers/ppeel/Treatments.jsx
 **/